import React, { Component } from 'react';
import PropTypes from 'prop-types';

class FuelMeterList extends Component {
  renderMeter(meter) {
    return (
      <p key={meter.id}>
        {meter.name}: {meter.totalQuantity}
      </p>
    );
  }

  render() {
    return (
      this.props.fuelMeters.map(fuelMeter =>
        this.renderMeter(fuelMeter))
    );
  }
}

FuelMeterList.propTypes = {
  fuelMeters: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired,
    totalQuantity: PropTypes.number.isRequired,
  }).isRequired).isRequired,
};

export default FuelMeterList;



// WEBPACK FOOTER //
// ./src/Containers/FuelTanks/FuelMetersList.js